
import React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import ShineEffect from "./ShineEffect";
import { getGlowClasses } from "@/hooks/useThemeContext";

interface AnimatedInputProps {
  inputValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  isFocused: boolean;
  hasInteracted: boolean;
  disabled?: boolean;
  isDark?: boolean;
  useGlow?: boolean;
  className?: string;
  onMouseUp?: (e: React.MouseEvent) => void;
  onKeyUp?: (e: React.KeyboardEvent) => void;
  [key: string]: any;
}

const inputMotionProps = {
  initial: { scale: 1 },
  animate: { 
    scale: 1.02,
    transition: { type: "spring", stiffness: 300, damping: 10 }
  },
  whileTap: { scale: 0.98 }
};

const AnimatedInput: React.FC<AnimatedInputProps> = ({
  inputValue,
  onChange,
  onFocus,
  onBlur,
  isFocused,
  hasInteracted,
  disabled = false,
  isDark = false,
  useGlow = false,
  className = "",
  onMouseUp,
  onKeyUp,
  ...props
}) => {
  return (
    <motion.div
      initial={{ scale: 1 }}
      animate={{ 
        scale: isFocused ? 1.02 : 1,
        transition: { type: "spring", stiffness: 300, damping: 10 }
      }}
      whileTap={{ scale: 0.98 }}
      className="relative"
    >
      <Input
        type="text"
        value={inputValue}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onMouseUp={onMouseUp}
        onKeyUp={onKeyUp}
        disabled={disabled}
        className={cn(
          "text-right transition-all duration-200",
          isFocused ? "border-primary shadow-sm ring-1 ring-primary/20" : "",
          hasInteracted && !isFocused ? "border-muted-foreground/30" : "",
          disabled ? "opacity-60" : "",
          useGlow && isFocused ? getGlowClasses(true, "primary") : "",
          className
        )}
        inputMode="decimal"
        {...props}
      />
      
      <ShineEffect isActive={isFocused} />
    </motion.div>
  );
};

export default AnimatedInput;
